export default "__VITE_ASSET__DBqu0iFo__"